type IconProps = { className?: string };

export function SfrBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#E2001A" />
      <path
        fill="#fff"
        d="M5.5 16.2V7.8h2.4l2.8 4.6 2.8-4.6h2.4v8.4h-2.1v-5.4l-2.5 4h-1.2l-2.5-4v5.4H5.5z"
      />
    </svg>
  );
}
